export default "__VITE_ASSET__B2Um$f7L__"